const moment = require('moment');

function isWeekend(date) {
    const isoWeekday = date.isoWeekday();
    return isoWeekday === 5 || isoWeekday === 6;
}

function subtractBusinessDays(date, days) {
    const result = moment(date);
    let remaining = days;

    while (remaining > 0) {
        result.subtract(1, 'day');
        if (!isWeekend(result)) {
            remaining -= 1;
        }
    }

    return result;
}

// The forward mirror of `subtractBusinessDays`, over the same weekend predicate. Used to
// project a deadline FROM a known start (e.g. when a request was created) rather than
// backwards from an auto-cancel date.
function addBusinessDays(date, days) {
    const result = moment(date);
    let remaining = days;

    while (remaining > 0) {
        result.add(1, 'day');
        if (!isWeekend(result)) {
            remaining -= 1;
        }
    }

    return result;
}

function countBusinessDaysUntil(date) {
    const target = moment(date).startOf('day');
    const cursor = moment().startOf('day');
    let count = 0;

    while (cursor.isBefore(target)) {
        cursor.add(1, 'day');
        if (!isWeekend(cursor)) {
            count += 1;
        }
    }

    return count;
}

// The one definition of "is there still a `days`-business-day buffer left before
// `targetDate`". Derived from `subtractBusinessDays` deliberately, so the date the UI
// DISPLAYS as the deadline and the cutoff that decides whether the option is OFFERED
// are the same date by construction.
//
// `countBusinessDaysUntil` cannot give that guarantee: walking backwards over the
// weekend and counting forwards over it are not inverse operations, so the two
// disagreed whenever the target fell on a Wednesday, Friday or Saturday — the option
// outliving its own displayed deadline by up to two days on a Wednesday, and dying a
// day early on a Friday or Saturday.
//
// Israeli public holidays COUNT as ordinary business days. Decided 2026-09-17 — this is
// settled, not a default waiting for a calendar: Friday and Saturday are the only
// non-business days in this module and in every consumer of it, so a deadline that lands
// on Yom Kippur or Pesach is the real deadline.
//
// ONE calendar question is still open and is NOT decided here. It cannot reintroduce the
// disagreement above, because it moves both sides together: which timezone defines
// "today". The browser runs on Israel time and the API container on UTC, so a business
// day is currently whatever day the running process is in.
function hasBusinessDayBuffer(targetDate, days, now) {
    if (!targetDate) {
        return false;
    }

    const deadline = subtractBusinessDays(targetDate, days).startOf('day');

    return !deadline.isBefore(moment(now).startOf('day'));
}

module.exports = {
    isWeekend,
    subtractBusinessDays,
    addBusinessDays,
    countBusinessDaysUntil,
    hasBusinessDayBuffer,
};
